import { render, staticRenderFns } from "./ManualLink.vue?vue&type=template&id=0d2231d1&scoped=true"
import script from "./ManualLink.vue?vue&type=script&lang=js"
export * from "./ManualLink.vue?vue&type=script&lang=js"
import style0 from "./ManualLink.vue?vue&type=style&index=0&id=0d2231d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2231d1",
  null
  
)

export default component.exports